import React from 'react'
import Header from '../header/Header'
import DuckSalepage from '../salepage/DuckSalepage'
import '../salepage/refractsalepage.css' // Inherit established V2 styles

const Duck = () => {
    return (
        <div className="duck-page-wrapper">
            <Header />
            <DuckSalepage />
        </div>
    )
}

export default Duck
